export default "__VITE_ASSET__BgMJ5vlp__"